<template>
  <v-container>
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-dialog v-model="detailDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">关联用户</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="editedDetailItem.userIdentity"
                  label="用户ID"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <!-- <v-text-field
                        v-model="editedDetailItem.validFrom"
                        label="生效时间"
                      ></v-text-field>-->
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="editedDetailItem.validFrom"
                      label="生效时间"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="editedDetailItem.validFrom"
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="6" md="6">
            <!--    <v-text-field
                  v-model="editedDetailItem.obsoletedFrom"
                  label="失效时间"
                ></v-text-field>-->
                 <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="editedDetailItem.obsoletedFrom"
                      label="失效时间"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="editedDetailItem.obsoletedFrom"
                    @input="menu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDetail"> 取消 </v-btn>
          <v-btn color="blue darken-1" text @click="saveDetail"> 保存 </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-data-table
      :headers="headers"
      :items="roles"
      sort-by="name"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>角色管理</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="800px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                新建角色
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        v-model="editedItem.name"
                        label="角色名称"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        v-model="editedItem.tag"
                        label="角色标签"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-show="editedIndex!=-1">
                    <v-btn
                      color="primary"
                      dark
                      class="mb-5"
                      small
                      outlined
                      @click="
                        editedDetailIndex = -1;
                        detailDialog = true;
                      "
                    >
                      关联用户
                    </v-btn>
                    <v-data-table
                      :headers="detailsHeaders"
                      :items="details"
                      sort-by="name"
                      class="elevation-1"
                    >
                      <template v-slot:item.actions="{ item }">
                        <v-icon
                          small
                          class="mr-2"
                          @click="editDetailItem(item)"
                        >
                          mdi-pencil
                        </v-icon>
                        <v-icon small @click="deleteDetailItem(item)">
                          mdi-delete
                        </v-icon>
                      </template>
                    </v-data-table>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close"> 取消 </v-btn>
                <v-btn color="blue darken-1" text @click="save"> 保存 </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="headline"
                >您确认是否删除改角色？</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete"
                  >取消</v-btn
                >
                <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                  >确定</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
        <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize"> 重置 </v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { roleService } from "@/api/role-service.js";
import moment, { months } from "moment";

export default {
  name: "roleManagement",
  data: () => ({
    menu:false,
    menu2:false,
    isLoading: false,
    dialog: false,
    detailDialog: false,
    dialogDelete: false,
    headers: [
      { text: "角色名称", value: "name" },
      { text: "角色标签", value: "tag" },
      { text: "操作", value: "actions", sortable: false },
    ],
    detailsHeaders: [
      { text: "用户ID", value: "userIdentity" },
      { text: "生效时间", value: "validFrom" },
      { text: "失效时间", value: "obsoletedFrom" },
      { text: "操作", value: "actions", sortable: false },
    ],
    roles: [],
    details: [],
    editedIndex: -1,
    editedDetailIndex: -1,
    editedItem: {
      name: "",
      tag: "",
    },
    defaultItem: {
      name: "",
      tag: "",
    },
    editedDetailItem: {
      userIdentity: "",
      validFrom: "",
      obsoletedFrom: "",
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "新建角色" : "编辑角色";
    },
    formDetailTitle() {
      return this.editedIndex === -1 ? "新关联用户" : "编辑角色";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      this.isLoading = true;
      this.roles = [];
      this.details = [];
      this.roles = await roleService.getRole();
      if (!this.roles) this.roles = [];
      this.isLoading = false;
    },

    async editItem(item) {
      this.isLoading = true;
      this.editedIndex = this.roles.indexOf(item);
      this.editedItem = Object.assign({}, item);
      let result = await roleService.getRoleDetail(item.identity);
      if (result.userDetail)
        this.details = result.userDetail.map((o) => ({
          userIdentity: o.userIdentity,
          validFrom: moment(o.validFrom).format("yyyy-MM-DD"),
          obsoletedFrom: moment(o.obsoletedFrom).format("yyyy-MM-DD"),
        }));
      this.isLoading = false;
      this.dialog = true;
    },

    editDetailItem(item) {
      this.editedDetailIndex = this.details.indexOf(item);
      this.editedDetailItem = Object.assign({}, item);
      this.detailDialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.roles.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    async deleteDetailItem(item) {
      this.isLoading = true;
      this.editedDetailIndex = this.details.indexOf(item);
      this.editedDetailItem = Object.assign({}, item);
      this.details.splice(this.editedDetailIndex, 1);
      let payload = {
        roleIdentity: this.editedItem.identity,
        userDetail: this.details,
      };
      await roleService.updateRoleDetail(payload);
      this.isLoading = false;
    },

    async deleteItemConfirm() {
      this.isLoading = true;
      await roleService.deleteRole(this.roles[this.editedIndex].identity);
      this.roles.splice(this.editedIndex, 1);
      this.closeDelete();
      this.isLoading = false;
    },

    close() {
      this.dialog = false;
      this.details = [];
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async save() {
      this.isLoading = true;

      if (this.editedIndex > -1) {
        Object.assign(this.roles[this.editedIndex], this.editedItem);
        let payload = {
          Identity: this.editedItem.identity,
          Name: this.editedItem.name,
          Tag: this.editedItem.tag,
        };
        await roleService.updateRole(payload);
      } else {
        this.roles.push(this.editedItem);
        let payload = {
          Identity: this.editedItem.identity,
          Name: this.editedItem.name,
          Tag: this.editedItem.tag,
        };
        await roleService.postRole(payload);
      }
      this.close();
      this.isLoading = false;
    },

    closeDetail() {
      this.detailDialog = false;
    },

    async saveDetail() {
      this.isLoading = true;

      if (this.editedDetailIndex > -1) {
        Object.assign(
          this.details[this.editedDetailIndex],
          this.editedDetailItem
        );
      } else {
        this.details.push(this.editedDetailItem);
      }

      let payload = {
        roleIdentity: this.editedItem.identity,
        userDetail: this.details,
      };
      await roleService.updateRoleDetail(payload);

      this.closeDetail();
      this.isLoading = false;
    },
  },
};
</script>

<style>
.v-data-table {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/management/RoleManagement.vue